'use client'

import { type AllHTMLAttributes, Fragment, useRef } from 'react'

import cn from 'clsx'

import {
    BaseField,
    type BaseFieldLabelVariant,
    type BaseFieldProps,
} from '../base-field/base-field'

import css from './text-area.module.css'

type NativeTextAreaProps = AllHTMLAttributes<HTMLTextAreaElement>

export type TextAreaProps = Omit<BaseFieldProps, 'action' | 'icon'> &
    BaseFieldLabelVariant & {
        value: NonNullable<NativeTextAreaProps['value']>
        onChange: NonNullable<NativeTextAreaProps['onChange']>
        onBlur?: NativeTextAreaProps['onBlur']
        onFocus?: NativeTextAreaProps['onFocus']
        onPaste?: NativeTextAreaProps['onPaste']
        placeholder?: NativeTextAreaProps['placeholder']
        rows?: number
    }

export function TextArea({
    id,
    value,
    onChange,
    onBlur,
    onFocus,
    placeholder,
    rows = 3,
    ...restProps
}: TextAreaProps) {
    const textareaRef = useRef<HTMLTextAreaElement | null>(null)

    return (
        <BaseField {...restProps} id={id} value={value} icon={undefined} action={undefined}>
            {({ className, ...fieldProps }, icon, action) => {
                return (
                    <Fragment>
                        {icon}
                        <textarea
                            value={value}
                            onChange={onChange}
                            onFocus={onFocus}
                            onBlur={onBlur}
                            placeholder={restProps.disabled ? undefined : placeholder}
                            rows={rows}
                            className={cn([className, css.textarea])}
                            {...fieldProps}
                            ref={textareaRef}
                        />
                        {action}
                    </Fragment>
                )
            }}
        </BaseField>
    )
}
